// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "dd9bb0e56d7da2ef22ec17cfce25a701e3cba2e4/static/js/" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"440":"486bdddc","581":"0843d95a","688":"2b6b0509","774":"772e6540"}[chunkId] + ".chunk.js";
};